import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  DrawShape: {
    '&__map': {
      '&__wrapper': {
        '&__fileInput': {
          padding: 10,
          marginBottom: 20,
          display: 'none',
          '&__span': {
            paddingLeft: 20,
          },
        },
        '&__icon': {
          display: 'flex',
          alignItems: 'center',
          backgroundColor: theme.palette.backgroundColor,
          border: `1px solid ${theme.palette.primary.main}`,
          borderRadius: '15px',
          color: theme.palette.primary.main,
          flexDirection: 'column',
          height: 120,
          justifyContent: 'space-evenly',
          position: 'absolute',
          right: 10,
          top: '20%',
          width: 30,
          zIndex: 1003,
          '&__map': {
            cursor: 'pointer',
            right: 10,
            '&:hover': {
              color: theme.palette.iconColor,
            },
            '&:visited': {
              color: theme.palette.iconColor,
            },
          },
        },
        '&__inner': {
          '&--height': {
            height: 'calc(100% - 80px)',
          },
        },
        '&__outer': {
          height: '100%',
          position: 'relative',
        },
      },
    },
  },
}));

export { useStyles };
